import axios from "axios";

export default {
  namespaced: true,
  state: {
    routeplans: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    routeplansMessage: ''
  },
  mutations: {
    RECEIVED_ROUTEPLANS(state, payload) {
      state.routeplans = payload;
      state.isReceiving = false;
    },
    RECEIVING_ROUTEPLANS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_ROUTEPLAN(state) {
      state.isReceiving = true;
    },
    RECEIVED_ROUTEPLAN(state, payload) {
      state = Object.assign(state, {
        routeplans: [...state.routeplans, payload],
        isReceiving: false,
      })
    },

    UPDATED_ROUTEPLANS(state, payload) {
      console.log(state.routeplans);
      console.log(payload);
      let index = state.routeplans.findIndex(routeplan => routeplan._id === payload._id);
      state = Object.assign(state, {
        routeplans: state.routeplans.map((routeplan, i) => {
          if (i === index) {
            return Object.assign({}, routeplan, payload);
          }
          return routeplan;
        }),
        isUpdating: false,
        routeplansMessage: 'RoutePlans has been updating!',
      })
    },
    UPDATING_ROUTEPLANS(state) {
      state.isUpdating = true;
    },
    DELETED_ROUTEPLANS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.routeplans.findIndex(routeplan => routeplan._id === payload._id);
      console.log(indexToDelete);
      let routeplans = [...state.routeplans];
      routeplans.splice(indexToDelete, 1);
      state = Object.assign(state, {
        routeplans: [...routeplans],
        isDeleting: false,
        idToDelete: null,
        routeplansMessage: 'RoutePlan has been Deleted!',
      });
    },
    DELETING_ROUTEPLANS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async runRoutePlansRequest({dispatch}, payload) {
      dispatch("receivingRoutePlans");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/run/routeplans';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post);
    },
    async insertRoutePlanRequest({dispatch}, payload) {
      dispatch("receivingRoutePlans");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/routeplan';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {dispatch("receiveRoutePlan", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertRouteAreaRequest({dispatch}, payload) {
      try{
        dispatch("receivingAreas");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/routearea/" + payload.routeplanid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data);
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    deleteRoutePlanRequest({dispatch}, payload) {
      dispatch("deletingRoutePlan", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/routeplan/' + payload._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      let del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(response=>{
        dispatch("deleteRoutePlan", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteRouteAreaRequest({dispatch}, id) {
      try{
        dispatch("receivingAreas");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/routearea/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    getRoutePlansRequest({dispatch}) {
      dispatch("receivingRoutePlans");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/routeplans';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        console.log(res.data)
        dispatch("receiveRoutePlans", res.data);
      })
    },
    async updateRoutePlanRequest({dispatch}, payload) {
      dispatch("updatingRoutePlan");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/routeplan/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateRoutePlan", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateRouteAreaRequest({dispatch}, payload) {
      try{
        dispatch("receivingAreas");
        var id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/update/routearea/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receiveRoutePlans({commit}, payload) {
      commit("RECEIVED_ROUTEPLANS", payload)
    },
    receivingAreas({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingRoutePlans({commit}) {
      commit("RECEIVING_ROUTEPLANS")
    },
    receiveRoutePlan({commit}, payload) {
      commit("RECEIVED_ROUTEPLAN", payload)
    },
    receivingRoutePlan({commit}) {
      commit("RECEIVING_ROUTEPLANS")
    },
    updateRoutePlan({commit}, payload) {
      commit("UPDATED_ROUTEPLANS", payload)
    },
    updatingRoutePlan({commit}) {
      commit("UPDATING_ROUTEPLANS")
    },
    deleteRoutePlan({commit}, payload) {
      commit("DELETED_ROUTEPLANS", payload)
    },
    deletingRoutePlan({commit}, payload) {
      commit("DELETING_ROUTEPLANS", payload)
    }
  },
};
